import { Injectable } from "@angular/core";
import { EnumRepositoryService } from "../../../helpers/crud/enumRepository.service";
import { WancomHttpService } from "../../../services/wancom-http/wancom-http.service";

@Injectable()
export class DiffusionDaysService extends EnumRepositoryService {
	constructor(http: WancomHttpService) {
		super(http, 'diffusionDays');
	}
}
